import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FieldBase from './FieldBase';

export default class BooleanField extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    submitted: PropTypes.bool,
    value: PropTypes.bool,
  };

  booleanSelected = e => {
    const selectedValue = e.target.value;
    this.props.onChange(selectedValue === 'yes' ? true : false);
  };

  render() {
    return (
      <FieldBase {...this.props}>
        <span>
          <label className="radio">
            Yes
            <input checked={this.props.value === true} value="yes" onChange={this.booleanSelected} type="radio" />
            <span />
          </label>
        </span>
        <span>
          <label className="radio push-half--left">
            No
            <input checked={this.props.value === false} value="no" onChange={this.booleanSelected} type="radio" />
            <span />
          </label>
        </span>
      </FieldBase>
    );
  }
}
